import React, { useState } from 'react';
import LeftMenu from './LeftMenu';
import './Dashboard.css';
import UserManagement from '../userManagement/UserManagement';
import ManageRole from '../manageRole/ManageRole';
import ManagePackage from '../managePackage/ManagePackage';
import ManageProduct from '../manageProduct/ManageProduct';
import ManageIndustry from '../manageIndustry/ManageIndustry';
import DashboardHome from './DashboardHome';

import {
  LEFT_MENU_ADMINISTRATION,
  LEFT_MENU_ROLE_AND_PERMISSION,
  LEFT_MENU_USER_MANAGEMENT,
  LEFT_MENU_MANAGE_RESOURCE,
  LEFT_MENU_MANAGE_PACKAGE,
  LEFT_MENU_MANAGE_PRODUCT,
  LEFT_MENU_MANAGE_INDUSTRY
} from '../../utils/constant';

function Dashboard() {
  const [selectedMenu, setSelectedMenu] = useState(null);

  const handleMenuSelect = (menuTitle) => {
    setSelectedMenu(menuTitle);
  };

  const renderContent = () => {
    if (selectedMenu === null) {
      return <DashboardHome />;
    }

    switch (selectedMenu) {
      case LEFT_MENU_USER_MANAGEMENT:
        return <UserManagement />;
      case LEFT_MENU_ROLE_AND_PERMISSION:
        return <ManageRole />;
      // case LEFT_MENU_MANAGE_PACKAGE:
      //   return <ManagePackage />;
      case LEFT_MENU_MANAGE_PRODUCT:
        return <ManageProduct />;
      case LEFT_MENU_MANAGE_INDUSTRY:
        return <ManageIndustry />;
      default:
        return <DashboardHome />;
    }
  };

  const menuItems = [
    LEFT_MENU_ADMINISTRATION,
    LEFT_MENU_MANAGE_RESOURCE
  ];

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        {menuItems.map((item) => (
          <LeftMenu
            key={item}
            title={item}
            onSelect={handleMenuSelect}
            activeMenuItem={selectedMenu}
          />
        ))}
      </div>
      <div className="content">
        {renderContent()}
      </div>
    </div>
  );
}

export default Dashboard;